import React, { ReactElement, useState } from "react";
import { useSelector } from "react-redux";
// react router
import { Navigate } from "react-router";
import { type UserState } from "../../types/types";

const ProtectedRoutes = ({ children }: { children: ReactElement }) => {
  const userToken = useSelector((state: UserState) => state.user.userToken);
  return userToken ? <>{children}</> : <Navigate to="/login" />;
};

export default ProtectedRoutes;
